var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('heading',[_vm._v(_vm._s(_vm.$t("sidebar.environmentalReports")))]),_c('dateFolderTable',{attrs:{"rows":_vm.rows,"loading":_vm.loading,"nameLabel":_vm.$t('folders.year')},on:{"open":_vm.openYear}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }